var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('Banner'),_c('Category'),_c('AboutUs'),_c('Why'),_c('News'),_c('Press'),_c('CustomerTalk'),_c('Help')],1)}
var staticRenderFns = []

export { render, staticRenderFns }